






import { defineComponent } from '@vue/composition-api'
import { entryHandler } from 'common/ts/entry-handler'
import { showNavBar } from './common/ts/handler-nav-bar'
export default defineComponent({
  name: 'app',
  setup() {
    // test
    console.log('start')
    showNavBar().catch(() => {
      // empty fn
    })
    entryHandler()
  }
})
